import { render, staticRenderFns } from "./CrmKanbanUi.vue?vue&type=template&id=75e2b074&scoped=true&lang=pug&"
import script from "./CrmKanbanUi.vue?vue&type=script&lang=js&"
export * from "./CrmKanbanUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmKanbanUi.vue?vue&type=style&index=0&id=75e2b074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e2b074",
  null
  
)

export default component.exports